import { useReactiveVar } from '@bestseller/retail-planning.utils.reactive-vars';
import { activeMonthVar } from 'src/infrastructure/local_state';

export const useActiveMonth = () => {
    return useReactiveVar(activeMonthVar);
};
